import type { Nullish } from '@iheartjane/types';

import { useMixpanelAnalyticsTags } from './useMixpanelAnalyticsTags';

/**
 * Hook to generate checkout URLs with analytics tags and promo code.
 * @param {object} options - Configuration options
 * @param {Nullish<string>} options.promoCode - Optional promo code to include in the URL
 * @returns {string} The checkout URL with analytics tags and promo code if available
 * @example
 * // For Button components that need full URLs
 * const { promoCode } = useRootLoaderData();
 * const checkoutUrl = useCheckoutLink({ promoCode });
 *
 * // Without any options
 * const checkoutUrl = useCheckoutLink();
 */
export const useCheckoutLink = ({
  promoCode,
}: { promoCode?: Nullish<string> } = {}): string => {
  const analyticsTags = useMixpanelAnalyticsTags();
  const params = new URLSearchParams(analyticsTags || '');
  if (promoCode) {
    params.set('promo_code', promoCode);
  }

  return params.toString() ? `/checkout?${params.toString()}` : `/checkout`;
};
